import { getHero } from '~/domain/cms/services/getHero.ts';
import { getMission } from '~/domain/cms/services/getMission.ts';
import { getTeam } from '~/domain/cms/services/getTeam.ts';
import { About } from './components/about.tsx';
import { Hero } from './components/hero.tsx';
import { Team } from './components/team.tsx';

export async function loader() {
  const [hero, mission, team] = await Promise.all([getHero(), getMission(), getTeam()]);

  return {
    hero,
    mission,
    team,
  };
}
export default function Index() {
  return (
    <>
      <Hero />
      <About />
      <Team />
    </>
  );
}
